export function useDataProcessingPolicy() {
  const open = useState<boolean>('data-processing-policy-modal', () => false)
  return { open, show: () => { open.value = true } }
}
